module.exports = __webpack_public_path__ + "static/team-training-1517b883e28429eedc01a693f5423067.jpg";